export const SIGN_UP_KIND_OPTIONS = [
  { label: 'Allied (Physician Assistants, CNAs, Techs, Therapists)', value: 'allied' },
  {
    label: 'Imaging Services (Radiology/X-ray, Ultrasound, CT, MRI Techs)',
    value: 'imaging_services',
  },
  { label: 'LVN / LPN', value: 'lvn' },
  { label: 'Registered Nurse (includes NPs)', value: 'registered_nurse' },
];
